import { Modal, Button } from "react-bootstrap";

import classes from "./detail.module.scss";

const Detail = ({ title, items, isOpen, handleClose }) => {
	return (
		<Modal show={isOpen} onHide={handleClose} backdrop="static" keyboard={false}>
			<Modal.Body>
				<div className={classes.div_detail}>
					<div className={classes.title}> {title} </div>
					<table className={classes.table}>
						<tbody>
							{items &&
								items.map((item, i) => {
									return (
										<tr key={i}>
											<td>{item}</td>
										</tr>
									);
								})}
						</tbody>
					</table>
				</div>
				<Modal.Footer style={{ paddingBottom: "1px", borderTop: "0px" }}>
					<Button style={{ fontSize: "0.8em" }} variant="danger" onClick={() => handleClose(false)}>
						CERRAR
					</Button>
				</Modal.Footer>
			</Modal.Body>
		</Modal>
	);
};

export default Detail;
